import { css } from 'aphrodite'
import PropTypes from 'prop-types'
import YoutubeIcon from '../../assets/youtube-icon.svg'
import { COLOR_WHITE } from '../../lib/colors'

const IconYoutube = ({ color = COLOR_WHITE, dynamicStyle }) => {
  return (
    <img
      src={YoutubeIcon}
      alt="Youtube icon"
      color={color}
      className={css(dynamicStyle)}
    />
  )
}

IconYoutube.propTypes = {
  color: PropTypes.string,
  dynamicStyle: PropTypes.object,
}

export default IconYoutube
